// ─────────────────────────────────────────────
//  AppShell.jsx — Shell PWA con navegación por tabs
//  Todas las secciones permanecen montadas para conservar estado
// ─────────────────────────────────────────────

import React, { useState, useEffect, useRef } from 'react';
import styles from './AppShell.module.css';
import TabBar, { SETTINGS_TAB_ID } from './TabBar';
import TipCalculator from '../tips/TipCalculator';
import PercentageCalculator from '../percentage/PercentageCalculator';
import PriceComparator from '../comparator/PriceComparator';
import WeightCostCalculator from '../weight/WeightCostCalculator';
import InvestmentCalculator from '../investment/InvestmentCalculator';
import Settings from '../settings/Settings';
import { getInitialTab, getSetting, setSetting, KEYS } from '../../utils/storage';

const SECTIONS = [
	{ id: 'tips',        Component: TipCalculator },
	{ id: 'porcentajes', Component: PercentageCalculator },
	{ id: 'comparar',    Component: PriceComparator },
	{ id: 'peso',        Component: WeightCostCalculator },
	{ id: 'inversion',   Component: InvestmentCalculator },
	{ id: SETTINGS_TAB_ID, Component: Settings },
];

export default function AppShell() {
	const [activeTab, setActiveTab] = useState(getInitialTab);
	const pageRef = useRef(null);

	useEffect(() => {
		if (getSetting(KEYS.rememberLastTab, true)) {
			setSetting(KEYS.lastTab, activeTab);
		}
	}, [activeTab]);

	useEffect(() => {
		if (pageRef.current) pageRef.current.scrollTop = 0;
	}, [activeTab]);

	return (
		<div className={styles.shell}>
			<div className={styles.page} ref={pageRef}>
				{SECTIONS.map(({ id, Component }) => (
					<div
						key={id}
						className={activeTab === id ? styles.sectionActive : styles.sectionHidden}
						hidden={activeTab !== id}
						aria-hidden={activeTab !== id}
					>
						<Component />
					</div>
				))}
			</div>
			<TabBar activeTab={activeTab} onTabChange={setActiveTab} />
		</div>
	);
}
